export default __webpack_public_path__ + "static/media/wireframesWeb.8e97bbfa.jpg";